import { Card, Heading, Stack, Stat, Text } from "@chakra-ui/react";
import { numberWithCommas } from "../utils/functions";
import useCustomTranslation from "../hooks/useCustomTranslation";
import { Children, useState } from "react";

// RE-DESIGN TO ONLY SHOW THE NAME AND THE BALANCE OWED
type StatCardProps = {
  children: any;
};
export const StatCard: React.FC<StatCardProps> = ({ children }) => {
  const { t, changeLanguage } = useCustomTranslation();

  const [isHovered, setIsHovered] = useState(false);
  return (
    <Stat
      boxShadow={"lg"}
      transform={isHovered ? "scale(1.03)" : "scale(1)"}
      transition="all 0.3s ease-in-out"
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
      cursor="pointer"
      borderWidth={1}
      borderRadius={10}
      p={5}
      textAlign={"center"}
      alignContent={"center"}
    >
      {children}
    </Stat>
  );
};
